<template>
  <section class="sec sec--nevoa">
    <div class="col">
      <div class="sec-cab sec-cab--centro">
        <span class="tag">Como funciona</span>
        <h2 class="sec-h2">Do pedido à entrega em 4 passos</h2>
      </div>

      <div class="trilha">
        <div
          v-for="(p, i) in PASSOS"
          :key="p.n"
          class="passo revela"
          :style="{ transitionDelay: (i * 0.09) + 's' }"
          v-revela
        >
          <div class="bolha">{{ i + 1 }}</div>
          <h3>{{ p.titulo }}</h3>
          <p>{{ p.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { PASSOS } from '@/config/operacao'
</script>

<style scoped>
.trilha { display: grid; grid-template-columns: repeat(4, 1fr); gap: 26px; position: relative; }

/* linha que conecta os passos, atrás das bolhas */
.trilha::before {
  content: '';
  position: absolute;
  top: 23px; left: 12%; right: 12%;
  height: 2px;
  background: linear-gradient(90deg, var(--azul-fundo), var(--azul) 50%, var(--azul-fundo));
  opacity: .55;
}

.passo { position: relative; z-index: 1; text-align: center; }
.bolha {
  width: 46px; height: 46px; border-radius: 50%;
  margin: 0 auto 18px;
  display: flex; align-items: center; justify-content: center;
  background: var(--azul); color: #fff;
  font-family: 'Archivo', sans-serif; font-weight: 800; font-size: 18px;
  box-shadow: 0 6px 16px -6px rgba(46, 127, 232, .9), 0 0 0 6px var(--nevoa);
}
.passo h3 { font-size: 16.5px; font-weight: 800; margin-bottom: 8px; }
.passo p { font-size: 13.5px; line-height: 1.62; color: var(--texto); }

@media (max-width: 900px) {
  .trilha { grid-template-columns: 1fr 1fr; gap: 30px 20px; }
  .trilha::before { display: none; }
}
@media (max-width: 520px) { .trilha { grid-template-columns: 1fr; } }
</style>
